var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.parent_data.show_dialog
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.parent_data.show_dialog,
            "before-close": _vm.closeBox,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.parent_data, "show_dialog", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "nodatawork" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticStyle: { "padding-left": "5%" },
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "150px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "公告标题:", prop: "title", required: "" }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "公告标题" },
                        model: {
                          value: _vm.form.title,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "公告内容:",
                        prop: "content",
                        required: ""
                      }
                    },
                    [
                      _c("vue-editor", {
                        attrs: {
                          config: _vm.uploadConfig,
                          "upload-handler": _vm.uploadHandler
                        },
                        model: {
                          value: _vm.form.content,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("发布规则")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: {
                            float: "left",
                            "margin-right": "20px"
                          },
                          attrs: { "true-label": "1", "false-label": "2" },
                          model: {
                            value: _vm.form.rule,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "rule", $$v)
                            },
                            expression: "form.rule"
                          }
                        },
                        [_vm._v("指定商家")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            float: "left",
                            "margin-right": "20px"
                          },
                          attrs: {
                            placeholder: "输入商家,至少3个字符",
                            "remote-method": _vm.fetchSupply,
                            remote: "",
                            filterable: "",
                            disabled: _vm.form.rule == 2
                          },
                          on: { change: _vm.add_supply },
                          model: {
                            value: _vm.supply,
                            callback: function($$v) {
                              _vm.supply = $$v
                            },
                            expression: "supply"
                          }
                        },
                        _vm._l(_vm.supplyOption, function(item, index) {
                          return _c("el-option", {
                            key: item.supply_id,
                            attrs: {
                              value: item.supply_id,
                              label: item.supply_name
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticStyle: { float: "left" },
                          attrs: {
                            name: "file",
                            action: _vm.action,
                            limit: 1,
                            accept: ".xls,.xlsx,.csv",
                            "file-list": _vm.filelist,
                            "on-success": _vm.importFile,
                            "auto-upload": true,
                            "with-credentials": ""
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "mini",
                                type: "primary",
                                disabled: _vm.form.rule == 2
                              },
                              slot: "trigger"
                            },
                            [_vm._v("导入商家")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip"
                            },
                            [
                              _vm._v(
                                "\n            注意：导入文件，则以导入为准，手动选择无效\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    _vm._l(_vm.select_supply, function(tag) {
                      return _vm.form.rule == 1
                        ? _c(
                            "el-tag",
                            {
                              key: tag.supply_id,
                              attrs: { closable: "", type: tag.supply_id },
                              on: {
                                close: function($event) {
                                  return _vm.delete_supply(tag)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(tag.supply_name) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否标杆商家:" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "是否标杆商家",
                            disabled: _vm.form.rule == 1
                          },
                          model: {
                            value: _vm.form.is_benchmarking,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "is_benchmarking", $$v)
                            },
                            expression: "form.is_benchmarking"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: "2", label: "全部" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: "1", label: "是" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: "0", label: "否" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商家等级:" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            placeholder: "商家等级",
                            disabled: _vm.form.rule == 1
                          },
                          model: {
                            value: _vm.form.supply_level,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "supply_level", $$v)
                            },
                            expression: "form.supply_level"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: "S", label: "S" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: "A", label: "A" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: "B", label: "B" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: "C", label: "C" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: "D", label: "D" }
                          }),
                          _vm._v(" "),
                          _c("el-option", { attrs: { value: "E", label: "E" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.publish_status == 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "redItem",
                          attrs: { label: "立即发布:", prop: "mobile" }
                        },
                        [
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: "1" },
                                model: {
                                  value: _vm.form.publish_now,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "publish_now", $$v)
                                  },
                                  expression: "form.publish_now"
                                }
                              },
                              [_vm._v("是")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              {
                                attrs: { label: "2" },
                                model: {
                                  value: _vm.form.publish_now,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "publish_now", $$v)
                                  },
                                  expression: "form.publish_now"
                                }
                              },
                              [_vm._v("否")]
                            )
                          ]
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.publish_now == 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "预约发布时间:" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.publish_time,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "publish_time", $$v)
                              },
                              expression: "form.publish_time"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.publish_status == 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "发布时间:" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.publish_time,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "publish_time", $$v)
                              },
                              expression: "form.publish_time"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.publish_status == 0
                    ? _c(
                        "el-form-item",
                        [
                          _c("el-button", { on: { click: _vm.closeBox } }, [
                            _vm._v("取消")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.submitData }
                            },
                            [_vm._v("确认")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41655bc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41655bc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/components/EditNotice.vue
// module id = null
// module chunks = 